<template>
  <div style="background: red;color:white;position: absolute; z-index: 1000000;display: none">{{ code }}</div>
  <div id="player" style="position: absolute;width: 100%;height: 100%;border: none"></div>
</template>
<script>
export default {
  name: 'pa-stream',
  data() {
    return {
      videoUrl: '',
      player: null,
      code: '',
    }
  },
  methods: {
    pause() {
      this.player.pauseVideo();
    },
    play() {
      this.player.playVideo();
    },
    stop() {
      this.player.stopVideo();
    },
    seek() {
      this.player.seekTo(this.player.playerInfo.currentTime + 5);
    },
    seekBack() {
      this.player.seekTo(this.player.playerInfo.currentTime - 5);
    },

  },
  mounted() {
    // eslint-disable-next-line no-undef
    this.player = new YT.Player('player', {
      events: {},
      videoId: this.$route.params.id,
      playerVars: {
        'autoplay': 1
      },
    });
    window.addEventListener('keydown', (e) => {
      this.code = e.keyCode;
      if (e.keyCode == 19) this.pause();
      if (e.keyCode == 179 || e.keyCode == 415) this.play();
      if (e.keyCode == 228 || e.keyCode == 417) this.seek();
      if (e.keyCode == 227 || e.keyCode == 412) this.seekBack();
      if (e.keyCode == 169 || e.keyCode == 413) {
        this.$router.go(-1);
      }
    })
    // this.videoUrl = 'https://www.youtube.com/embed/' + this.$route.params.id + '?autoplay=1';
  }
}
</script>
